import request from '@/utils/requestVr'
// 查询空间套餐列表分页
export function fetchList(query) {
    return request({
        url: '/vr/storage/package/page',
        method: 'get',
        params: query,
    })
}
// 查询空间套餐列表分页对外
export function fetchLists(query) {
    return request({
        url: '/vr/storage/package/page/way',
        method: 'get',
        params: query,
    })
}
// 查询空间套餐详细
export function getObj(id) {
    return request({
        url: '/vr/storage/package/detail?id=' + id,
        method: 'get',
    })
}
// 新增空间套餐
export function addObj(data) {
    return request({
        url: '/vr/storage/package/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用空间套餐
export function editStatus(data) {
    return request({
        url: '/vr/storage/package/status',
        method: 'post',
        data: data,
    })
}
// 修改空间套餐
export function putObj(data) {
    return request({
        url: '/vr/storage/enterprise/temp/edit',
        method: 'post',
        data: data,
    })
}
// 删除空间套餐
export function delObj(data) {
    return request({
        url: '/vr/storage/package/delete',
        method: 'post',
        data: data,
    })
}

export function creatOrder(data) {
    return request({
        url: '/vr/storage/purchase/record/add/personal',
        method: 'post',
        data: data,
    })
}
export function creatOrderqiye(data) {
    return request({
        url: '/vr/storage/purchase/record/add',
        method: 'post',
        data: data,
    })
}

export function checkPayStatus(params) {
    return request({
        url: '/vr/storage/purchase/record/pay/status',
        method: 'get',
        params,
    })
}
